import DateFieldBase from '../base/DateField';
import createField from './createField';

const DateField = createField(DateFieldBase);

export default DateField;
